var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4994 1.02869C13.4622 1.02869 15.3522 1.5995 16.9899 2.68528L11.643 8.38782L6.94958 2.12999C8.35348 1.40817 9.91869 1.02869 11.4994 1.02869Z",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3995 19.0369L13.5293 11.2961L19.4475 4.98244C20.754 6.70823 21.4711 8.83224 21.4711 10.9999C21.4711 14.1775 19.9547 17.1583 17.3995 19.0369Z",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.05716 3.88008L4.05936 3.88302L4.05717 3.88007L4.05716 3.88008ZM1.5289 11.0001C1.5289 8.42707 2.49408 6.00927 4.25848 4.14845L10.0384 11.8533L14.3877 20.5367C13.4381 20.8259 12.4698 20.9712 11.5 20.9712C6.00249 20.9712 1.5289 16.4972 1.5289 11.0001Z",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.cc2c27a929c4bc24ba447896ced79557.svg";
export { ForwardRef as ReactComponent };